/**
 * Fastest/slowest lap selection over a zone's per-lap data — ONE tie-break
 * convention (first lap in the given order wins) shared by both clients' lap
 * tables and the consistency attribution, so their ★/slowest markers can
 * never disagree.
 */
import { type ZoneLapData } from '../../zones/TrackZoneTypes'

/** Lap with the lowest zone time; first in input order on ties. */
export function fastestZoneLapId(lapData: ZoneLapData[]): string | null {
  let best: ZoneLapData | null = null
  for (const l of lapData) {
    if (!best || l.zoneTimeMs < best.zoneTimeMs) best = l
  }
  return best?.lapId ?? null
}

/** Lap with the highest zone time; first in input order on ties. */
export function slowestZoneLapId(lapData: ZoneLapData[]): string | null {
  let worst: ZoneLapData | null = null
  for (const l of lapData) {
    if (!worst || l.zoneTimeMs > worst.zoneTimeMs) worst = l
  }
  return worst?.lapId ?? null
}
